import styled from 'styled-components';

export const StepperContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  background-color: ${props => props.theme.backgroundColor};
  max-width: 525px;
  height: 50px;
`;
